import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 12px;
  color: white;

  .x-viewport-xs & {
    padding: 8px;

    &.titleblock {
      padding: 10px;
    }
  }

  .x-viewport-md & {
    padding: 12px;
  }
`;
